<template>
  <div class="symbol-logo" :class="`logo-${logos.length || 'fallback'}`">
    <template v-if="logos.length">
      <img
        v-for="(l, i) in logos"
        :key="i"
        :src="l.src"
        :alt="l.alt"
        @error="onImgError(i)"
        class="symbol-logo__img"
      />
    </template>
    <div v-else class="symbol-logo__fallback" :style="fallbackStyle">
      {{ fallbackText }}
    </div>
  </div>
</template>

<script>
import { logosFor, initials } from '@/components/graph/symbolMeta.js'

const PALETTE = [
  '#22b7c4', '#5b8def', '#e0a13c', '#d65a73',
  '#6cab74', '#a36ed1', '#d68850', '#3aa9a4',
]

export default {
  name: 'SymbolLogo',
  props: {
    symbol: { type: Object, required: true },
    size:   { type: Number, default: 28 },
  },
  data() {
    return { failed: new Set() }
  },
  computed: {
    logos() {
      const all = logosFor(this.symbol)
      // Filter out logos that errored on load — fall back to text avatar.
      return all.filter((_, i) => !this.failed.has(i))
    },
    fallbackText() {
      return initials(this.symbol)
    },
    fallbackStyle() {
      const seed = (this.fallbackText.charCodeAt(0) || 65) % PALETTE.length
      return {
        background: PALETTE[seed],
        width:  `${this.size}px`,
        height: `${this.size}px`,
        lineHeight: `${this.size}px`,
        fontSize: `${Math.round(this.size * 0.42)}px`,
      }
    },
  },
  methods: {
    onImgError(i) {
      this.failed.add(i)
      // Force re-render by reassigning the set.
      this.failed = new Set(this.failed)
    },
  },
}
</script>

<style scoped lang="scss">
.symbol-logo {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.symbol-logo__img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  background: #1f2937;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.logo-2 .symbol-logo__img:not(:first-child) {
  margin-left: -8px;
  z-index: 0;
}

.logo-2 .symbol-logo__img:first-child {
  z-index: 1;
}

.symbol-logo__fallback {
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}
</style>
